import { Link } from "react-router-dom";
import Header from "../components/Header";
import { Compass, ArrowRight } from "@phosphor-icons/react";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-white" data-testid="not-found-page">
      <Header minimal />
      <main className="max-w-[720px] mx-auto px-6 py-24 text-center">
        <div className="pg-overline mb-4">404 - page not found</div>
        <div className="font-heading text-[120px] sm:text-[180px] font-black tracking-tighter leading-none text-[#002FA7]">404</div>
        <h1 className="font-heading text-3xl sm:text-4xl font-extrabold tracking-tight mt-2">
          This page didn't survive the audit.
        </h1>
        <p className="text-[#52525b] mt-4 max-w-md mx-auto">
          The URL you tried doesn't exist on PriceGuard NZ. It may have moved, expired, or never existed in the first place.
        </p>
        <div className="mt-10 flex flex-col sm:flex-row gap-3 justify-center">
          <Link to="/" className="bg-[#002FA7] text-white font-bold px-6 py-3 inline-flex items-center justify-center gap-2 hover:bg-[#00207A]" data-testid="not-found-home-btn">
            Back to home <ArrowRight size={16} weight="bold" />
          </Link>
          <Link to="/dashboard" className="border border-black font-bold px-6 py-3 inline-flex items-center justify-center gap-2 hover:bg-black hover:text-white" data-testid="not-found-dashboard-btn">
            <Compass size={16} weight="bold" /> Go to dashboard
          </Link>
        </div>
      </main>
    </div>
  );
}
